<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>查調類別</td>
                  <td>
                    <select v-model="form.type" @change="changeYear(form.type)">
                      <option value="1">申報人授權</option>
                      <option value="2">抽籤名單</option>
                    </select>
                  </td>
                  <td>
                    年度
                    <select
                      v-model="form.syear"
                      @change="syearChange(form.type)"
                    >
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                  <td v-show="form.type == '1'">
                    <span v-if="isExpand">查調批號</span>
                    <span v-if="!isExpand">查調日期</span>
                    <select
                      v-model="form.authOpenDate"
                      @change="authOpenDateChange()"
                      :disabled="form.syear == '' || form.syear == null"
                    >
                      <option value="" selected disabled hidden>請選擇</option>
                      <option
                        v-for="(data, index) in dropDownList.authOpenDates"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                    批次適用區間:{{ form.stSdate }}至{{ form.endSdate }}
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號</td>
                  <td>
                    <input type="text" v-model="form.idn" />
                  </td>
                  <td>姓名</td>
                  <td>
                    <input type="text" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="
                            () => {
                              this.form.currentpage = 1;
                              this.form.pagesize = 10;
                              this.reQuery('', '');
                            }
                          "
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid.gridDatas">
            <tbody>
              <tr>
                <td>
                  已送人數：<span>{{ grid.rateS ? grid.rateS : 0 }}</span>
                  &nbsp;&nbsp; 已授權人數：<span>{{
                    grid.rateM ? grid.rateM : 0
                  }}</span>
                  &nbsp;&nbsp; 已授權申報人數：<span>{{
                    grid.rateA ? grid.rateA : 0
                  }}</span>
                </td>
              </tr>
              <tr v-if="grid.paginaiton">
                <td>
                  <button class="btn" @click="btnAllCheck()">全選</button>
                  <button class="btn" @click="btnCancelCheck()">取消</button>
                  <input
                    type="submit"
                    class="btn"
                    value="整批送審"
                    @click="btnSend(grid.gridDatas)"
                  />
                </td>
                <td align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th style="min-width: 50px"></th>
                    <th>操作</th>
                    <th v-show="form.type == '1'">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('Surveyday', Sort);
                          }
                        "
                        ><span v-if="isExpand">查調批號</span>
                        <span v-if="!isExpand">查調日期</span></u>
                    </th>
                    <th v-show="form.type == '1' && isExpand">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('Baseday', Sort);
                          }
                        "
                        >查調基準日</u
                      >
                    </th>                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('name', Sort);
                          }
                        "
                        >姓名</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('idn', Sort);
                          }
                        "
                        >身分證統一編號</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('goV_CODE', Sort);
                          }
                        "
                        >受理申報機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('tel', Sort);
                          }
                        "
                        >聯絡電話</u
                      >
                    </th>
                    <th>已送出人數/已授權總人數</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="checkbox"
                        v-model="form.visibles"
                        v-show="data.visible"
                        :value="data.autH_SEQ"
                      />
                    </td>
                    <td
                      width="1%"
                      align="center"
                      v-if="
                        data.inpuT_TYPE == '1' &&
                        grid.isAuthTime &&
                        data.dtype != '6'
                      "
                    >
                      <input
                        type="button"
                        class="btn"
                        value="編"
                        :disabled="data.inpuT_TYPE == '1' && data.dtype == '6'"
                        @click="btnEdit(data)"
                      />
                    </td>
                    <td width="1%" align="center" v-else>
                      <input
                        v-if="data.inpuT_TYPE == '2'"
                        type="button"
                        class="btn"
                        value="編"
                        :disabled="data.inpuT_TYPE == '2' && data.rate == '0/0'"
                        @click="btnEdit(data)"
                      />
                      <input
                        v-else
                        type="button"
                        class="btn"
                        value="查"
                        :disabled="data.inpuT_TYPE == '2' && data.rate == '0/0'"
                        @click="btnEdit(data)"
                      />
                    </td>
                    <td v-show="form.type == '1'">{{ data.surveyDay }}</td>
                    <td v-show="form.type == '1' && isExpand">{{ data.baseDay }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.idn }}</td>
                    <td>{{ data.goV_NAME }}</td>
                    <td>{{ data.tel }}</td>
                    <td :style="{ color: GetRateColor(data.rate) }">
                      {{ data.rate }}
                    </td>
                  </tr>
                  <tr v-if="!grid && !grid.gridDatas">
                    <td colspan="7" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <Modal
      v-model="modal.show"
      :title="modal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>關係人</td>
                <td>
                  {{ modal.form.name }}
                  &nbsp;
                  <input
                    type="checkbox"
                    name="SingleFLAG"
                    v-model="modal.form.SingleFLAG"
                    :disabled="
                      (form.type == '1' && !modal.grid.isAuthTime) ||
                      modal.PreData.type == '6'
                    "
                  />
                  <label for="SingleFLAG">單親撫養</label>
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    v-model="modal.form.familyName"
                    :disabled="
                      (form.type == '1' && !modal.grid.isAuthTime) ||
                      modal.PreData.type == '6'
                    "
                  />
                </td>
                <td>身分證統一編號</td>
                <td>
                  <input
                    type="text"
                    v-model="form.familyIDN"
                    :disabled="
                      (form.type == '1' && !modal.grid.isAuthTime) ||
                      modal.PreData.type == '6'
                    "
                  />
                </td>
              </tr>
              <tr>
                <td>關係</td>
                <td>
                  <select
                    v-model="modal.form.familyTitle"
                    :disabled="
                      (form.type == '1' && !modal.grid.isAuthTime) ||
                      modal.PreData.type == '6'
                    "
                  >
                    <option value="1">配偶</option>
                    <option value="2">子</option>
                    <option value="3">女</option>
                  </select>
                </td>
                <td>出生年月日</td>
                <td>
                  <DatePicker
                    v-model="modal.form.familyBirthday"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    :disabled="
                      (form.type == '1' && !modal.grid.isAuthTime) ||
                      modal.PreData.type == '6'
                    "
                  /><br />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="新增"
                        @click="btnModalAdd()"
                        :disabled="
                          EditFlag ||
                          (form.type == '1' && !modal.grid.isAuthTime) ||
                          modal.PreData.type == '6'
                        "
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="修改"
                        @click="btnModalSave()"
                        :disabled="
                          !EditFlag ||
                          (form.type == '1' && !modal.grid.isAuthTime) ||
                          modal.PreData.type == '6'
                        "
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnModalClear()"
                        :disabled="
                          (form.type == '1' && !modal.grid.isAuthTime) ||
                          modal.PreData.type == '6'
                        "
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="查看歷程"
                        @click="btnHistoryModal()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
      <!-- 查詢結果開始-->
      <div class="information">
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th colspan="6">操作</th>
                  <th>姓名</th>
                  <th>身分證統一編號</th>
                  <th>關係</th>
                  <th>實質審核/授權</th>
                  <th>授權時間</th>
                  <th>一級機關送審時間</th>
                  <th>授權方式</th>
                </tr>
              </thead>
              <tbody v-if="modal.grid">
                <tr v-for="(data, index) in modal.grid.gridDatas" :key="index">
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="編"
                      @click="btnModalEdit(data)"
                      :disabled="
                        !data.btnUpdate ||
                        (form.type == '1' && !modal.grid.isAuthTime) ||
                        modal.PreData.type == '6'
                      "
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="刪"
                      @click="btnDelete(data)"
                      :disabled="
                        !data.btnDelete ||
                        (form.type == '1' && !modal.grid.isAuthTime) ||
                        modal.PreData.type == '6'
                      "
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="授權"
                      @click="btnModalAuth(data)"
                      :disabled="
                        !data.btnAuth ||
                        (form.type == '1' && !modal.grid.isAuthTime) ||
                        modal.PreData.type == '6'
                      "
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="取消授權"
                      @click="btnModalCancelAuth(data)"
                      :disabled="
                        !data.btnCancelAuth ||
                        (form.type == '1' && !modal.grid.isAuthTime) ||
                        modal.PreData.type == '6'
                      "
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="送審"
                      :disabled="
                        !data.btnSend ||
                        (form.type == '1' && !modal.grid.isAuthTime) ||
                        modal.PreData.type == '6'
                      "
                      @click="btnModalSend(data)"
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="退回"
                      :disabled="
                        data.subOneDateTime != '' ||
                        (form.type == '1' && !modal.grid.isAuthTime) ||
                        modal.PreData.type == '6'
                      "
                      @click="btnModalBack(data)"
                    />
                  </td>
                  <td>{{ data.familyName }}</td>
                  <td>{{ data.familyIDN }}</td>
                  <td>{{ data.familyTitleText }}</td>
                  <td>{{ data.type }}</td>
                  <td>{{ data.warrantDay }}</td>
                  <td>{{ data.subOneDateTime }}</td>
                  <td>{{ data.warrantClass }}</td>
                </tr>
                <tr v-if="!modal.grid && !modal.grid.gridDatas">
                  <td colspan="11" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </Modal>
    <!-- 歷程查詢 -->
    <HistoryModal
      v-model="historyModal.show"
      :title="historyModal.title"
      :modalStyle="{ 'max-width': '1000px' }"
    >
      <div class="information">
        <table width="100%">
          <tbody>
            <tr v-for="(data, index) in historyModal.grid.files" :key="index">
              <td>
                授權書：<a
                  :href="'data:' + data.fileType + ';base64,' + data.fileString"
                  :download="data.fileName"
                >
                  {{ data.fileName }}
                </a>
                &nbsp;
              </td>
            </tr>
          </tbody>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>年度</th>
                  <th><span v-if="isExpand">查調批號</span>
                    <span v-if="!isExpand">查調日期</span></th>
                  <th>姓名</th>
                  <th>身分證字號</th>
                  <th>關係</th>
                  <th>狀態</th>
                  <th>授權時間</th>
                  <th>執行動作</th>
                  <th>異動時間</th>
                  <th>異動人員</th>
                </tr>
              </thead>
              <tbody
                v-if="
                  historyModal.grid &&
                  historyModal.grid.logs &&
                  historyModal.grid.logs.length > 0
                "
              >
                <tr
                  v-for="(data, index) in historyModal.grid.logs"
                  :key="index"
                >
                  <td>{{ data.syear }}</td>
                  <td>{{ data.surveyDay }}</td>
                  <td>{{ data.familyName }}</td>
                  <td>{{ data.familyIdn }}</td>
                  <td>{{ data.familyTitle }}</td>
                  <td>{{ data.status }}</td>
                  <td>{{ data.authDate }}</td>
                  <td>{{ data.warrantClass }}</td>
                  <td>{{ data.updateDateTime }}</td>
                  <td>{{ data.updateUserId }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 查詢結果結束-->
      </div>
    </HistoryModal>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :enableClose="Alert.enableClose"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <AlertDel v-model="AlertDel.show" :title="AlertDel.title">
      <div style="text-align: center">
        <p>確定要刪除資料嗎?</p>
        <div>
          <button class="btn" @click="btnModalDel()">確定</button>
          <button class="btn" @click="AlertDel.show = false">取消</button>
        </div>
      </div>
    </AlertDel>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import {
  ChkIDorRCNumber,
  getMenuIndex,
  getMenu,
  logOut,
} from "@/config/util.js";
import {
  M_GetAuthOpenTime,
  SearchGovCode,
  M106_SearchGrid3,
  SearchM1063FGridType2,
  M102_SearchGrid,
  M102_ReSearchGrid,
  M102_SearchGrid2,
  M1012_Modify,
  M1012_SendAuth,
  M1012_BackAuth,
  M1012_UploadFileAuthorize,
  M104_SearchDropDown,
} from "@/service/api.js";
export default {
  name: "M102",
  data: function () {
    return {
      pageData: {
        MenuIndex: 5,
        MenuName: "",
        PrgName: "M102",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      isExpand: false,
      form: {
        idn: "",
        name: "",
        syear: "",
        authOpenDate: "",
        stSdate: "",
        endSdate: "",
        type: "1",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        pagesize: 10,
        currentpage: 1,
        visibles: [],
      },
      dropDownList: {
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
        syears: [],
        authOpen: [],
        authOpenDates: [],
      },
      grid: [],
      modal: {
        show: false,
        title: "M102查調(授權)名單管理-編輯",
        grid: [],
        form: {
          name: "",
          familyIDN: "",
          familyName: "",
          familyTitle: "",
          familyBirthday: "",
          SingleFLAG: false,
          authDet_SEQ: 0,
          oneSeq: 0,
        },
        PreData: {},
      },
      historyModal: {
        show: false,
        title: "授權歷程查詢",
        grid: {},
      },
      Alert: {
        enableClose: false,
        show: false,
        title: "",
        txt: "",
      },
      AlertDel: {
        show: false,
        title: "",
        form: {
          authDet_SEQ: 0,
        },
      },
      EditFlag: false,
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    HistoryModal: VueModal,
    Modal: VueModal,
    Alert: VueModal,
    AlertDel: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    getSyearDropDownList: function () {
      const self = this;
      let syears = [];
      for (
        let i = new Date().getFullYear() - 1911;
        i > new Date().getFullYear() - 1911 - 10;
        i--
      ) {
        syears.push(i.toString());
      }
      self.form.syear = syears[0];
      self.syearChange(self.form.type);
      return syears;
    },
    //第一頁按紐查詢
    doQuery: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      let errorMsg = [];
      if (self.form.syear.trim() == "") {
        errorMsg.push("請填寫年度");
      }

      if (self.form.type == "1" && self.form.authOpenDate.trim() == "") {
        errorMsg.push("請填寫查調日期");
      }

      //add
      if(self.form.type == "2"){
        self.form.authOpenDate = "";
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        SYEAR: self.form.syear,
        TYPE: self.form.type,
        authOpenDate: self.form.authOpenDate,
        stSdate: self.form.stSdate,
        endSdate: self.form.endSdate,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: self.form.jobGovCheck,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M102_SearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      let errorMsg = [];
      if (self.form.syear.trim() == "") {
        errorMsg.push("請填寫年度");
      }

      if (self.form.type == "1" && self.form.authOpenDate.trim() == "") {
        errorMsg.push("請填寫查調日期");
      }

      //add
      if(self.form.type == "2"){
        self.form.authOpenDate = "";
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "Auth_SEQ";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        SYEAR: self.form.syear,
        authOpenDate: self.form.authOpenDate,
        stSdate: self.form.stSdate,
        endSdate: self.form.endSdate,
        TYPE: self.form.type,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: self.form.jobGovCheck,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      debugger;
      M102_ReSearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁按紐重填
    btnClear: function () {
      const self = this;
      self.form = {
        idn: "",
        name: "",
        syear: String(new Date().getFullYear() - 1911 - 1),
        type: "1",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        authOpenDate: "",
        currentpage: 1,
        pagesize: 10,
        visibles: [],
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    //第一頁按紐編
    btnEdit: function (data) {
      const self = this;
      self.M102_SearchGrid2(data);
      self.btnModalClear();
      self.modal.form.name = data.name;
      self.modal.form.authOpenDate = data.surveyDay;
      self.modal.PreData = data;
      self.modal.show = true;
      self.modal.form.familyTitle = "";
      self.EditFlag = false;
    },
    GetRateColor: function (data) {
      let rowsM = data.split("/")[0];
      let rowsS = data.split("/")[1];
      if (rowsS != rowsM) {
        return "Red";
      } else {
        if (rowsM == 0) {
          return "Gray";
        } else {
          return "SkyBlue";
        }
      }
    },
    //全選
    btnAllCheck: function () {
      const self = this;
      self.form.visibles = [];
      self.grid.gridDatas.forEach((g) => {
        if (g.visible) self.form.visibles.push(g.autH_SEQ);
      });
    },
    //取消
    btnCancelCheck: function () {
      const self = this;
      self.form.visibles = [];
    },
    //第一頁整批送審
    btnSend: function (data) {
      const self = this;
      let postData = {
        enterPage: "M102",
        Auth_SEQ: self.form.visibles,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第一頁整批送審",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      debugger;
      M1012_SendAuth(postData).then((rData) => {
        //console.log(rData);
        var msg = [];
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push(rData.messages[rData.messages.length - 1]);
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => {
            if (self.Sort == "ASC") {
              self.Sort = "DESC";
            } else {
              self.Sort = "ASC";
            }
            self.reQuery(self.Order, self.Sort);
            //self.M101_SearchGrid2(self.modal.PreData);
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          msg.push("M102送審錯誤");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁GRID API
    M102_SearchGrid2: function (data) {
      const self = this;
      let postData = {
        type: self.form.type,
        syear: self.form.syear,
        familyidn: data.idn,
        name: data.name,
        goV_CODE: data.goV_CODE,
        surveyDay: self.form.authOpenDate,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "編",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      M102_SearchGrid2(postData).then((rData) => {
        if (rData.result) {
          self.modal.grid = rData.returnObject.returnObject;
          self.modal.form.oneSeq = self.modal.grid.oneSeq;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    //第二頁修改api
    btnModify: function (modifyObj) {
      const self = this;

      let postData = {
        modifiedType: modifyObj.type,
        enterPage: "M102",
        autH_SEQ:
          self.modal.PreData.autH_SEQ == 0
            ? self.modal.grid.gridDatas[0].auth_SEQ
            : self.modal.PreData.autH_SEQ,
        authDet_SEQ: modifyObj.authDet_SEQ,
        oneSeq: self.modal.grid.oneSeq,
        // fileName: null,
        // fileType: null,
        // fileString: null,
        singleFlag: self.modal.form.SingleFLAG,
        familyName: self.modal.form.familyName,
        familyIDN: self.modal.form.familyIDN,
        familyTitle: self.modal.form.familyTitle,
        familyBirthday: self
          .$moment(self.modal.form.familyBirthday)
          .format("YYYYMMDD"),
        //M103 紙本&&電子
        type: self.form.type,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁修改",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      if (self.modal.form.file != undefined) {
        postData = {
          modifiedType: modifyObj.type,
          enterPage: "M102",
          autH_SEQ:
            self.modal.PreData.autH_SEQ == 0
              ? self.modal.grid.gridDatas[0].auth_SEQ
              : self.modal.PreData.autH_SEQ,
          authDet_SEQ: modifyObj.authDet_SEQ,
          oneSeq: self.modal.grid.oneSeq,
          fileName: self.modal.form.file.fileName,
          fileType: self.modal.form.file.fileType,
          fileString: self.modal.form.file.fileString,
          singleFlag: self.modal.form.SingleFLAG,
          familyName: self.modal.form.familyName,
          familyIDN: self.modal.form.familyIDN,
          familyTitle: self.modal.form.familyTitle,
          familyBirthday: self
            .$moment(self.modal.form.familyBirthday)
            .format("YYYYMMDD"),
          //M103 紙本&&電子
          type: "",
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁修改",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
      }
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      M1012_Modify(postData).then((rData) => {
        var msg = [];
        if (rData.result) {
          self.Alert.enableClose = false;
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push(modifyObj.alertMsg);
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => {
            self.M102_SearchGrid2(self.modal.PreData);
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          msg.push("ModifyM1022API錯誤");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁新增
    btnModalAdd: function () {
      const self = this;
      let errorMsg = [];
      var familybool = false;
      // var resultfamilydata = self.modal.form;
      // var i = 0;
      //先修改暫存看看
      // resultfamilydata.splice(self.modal.form.familyIDN, 1, {
      //   title: self.modal.form.familyTitle,
      //   name: self.modal.form.name,
      //   familyBirthday: self.modal.form.familyBirthday,
      // });
      // resultfamilydata.forEach((x) => {
      //   if (x.title == "1") {
      //     i = i + 1;
      //   }
      //   //超過兩個配偶不行
      //   if (i >= 2) familybool = true;
      // });
      if (self.modal.form.familyName.trim() == "") {
        errorMsg.push("請填寫姓名");
      }

      if (self.modal.form.familyIDN.trim() == "") {
        errorMsg.push("請填寫身分證統一編號");
      } else {
        if (!ChkIDorRCNumber(self.modal.form.familyIDN)) {
          errorMsg.push("身分證統一編號格式不對");
        }
      }

      if (self.modal.form.familyTitle == "") {
        errorMsg.push("請填寫關係");
      }

      if (self.modal.form.familyBirthday == "") {
        errorMsg.push("請填寫出生年月日");
      } else {
        if (
          self.modal.form.familyTitle != "1" &&
          new Date(self.modal.form.familyBirthday) <=
            new Date(
              dateNow.getFullYear() - 18,
              dateNow.getMonth(),
              dateNow.getDate()
            )
        ) {
          errorMsg.push("生日錯誤(生日之人已成年)");
        }
      }

      if (
        self.modal.grid.gridDatas.filter(
          (x) => x.familyIDN === self.modal.form.familyIDN
        ).length > 0
      ) {
        errorMsg.push("身分證統一編號不得重複");
      }

      if (
        self.modal.form.familyTitle == "1" &&
        self.modal.grid.gridDatas.filter(
          (x) =>
            x.authDet_SEQ !== self.modal.form.authDet_SEQ &&
            x.familyTitle === self.modal.form.familyTitle
        ).length > 0
      ) {
        // if (familybool) {
        errorMsg.push("「配偶」(已有配偶資料，不可修改!)");
      }
      var dateNow = new Date(
        self.form.authOpenDate.substring(0, 4) +
          "-" +
          self.form.authOpenDate.substring(4, 6) +
          "-" +
          self.form.authOpenDate.substring(6, 8)
      );

      if (new Date(self.modal.form.familyBirthday) > new Date(Date.now())) {
        errorMsg.push("生日不可大於系統日");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      const modifyObj = {
        type: "I",
        authDet_SEQ: self.modal.form.authDet_SEQ,
        alertMsg: "新增成功",
      };
      this.btnModify(modifyObj);
    },
    //第二頁修改
    btnModalSave: function () {
      const self = this;
      let errorMsg = [];
      if (self.modal.form.familyName == "") {
        errorMsg.push("請填寫姓名");
      }

      if (self.modal.form.familyIDN == "") {
        errorMsg.push("請填寫身分證統一編號");
      } else {
        if (!ChkIDorRCNumber(self.modal.form.familyIDN)) {
          errorMsg.push("身分證統一編號格式不對");
        }
      }

      if (self.modal.form.familyTitle == "") {
        errorMsg.push("請填寫關係");
      }

      if (self.modal.form.familyBirthday == "") {
        errorMsg.push("請填寫出生年月日");
      } else {
        if (
          self.modal.form.familyTitle != "1" &&
          new Date(self.modal.form.familyBirthday) <=
            new Date(
              dateNow.getFullYear() - 18,
              dateNow.getMonth(),
              dateNow.getDate()
            )
        ) {
          errorMsg.push("生日錯誤(生日之人已成年)");
        }
      }

      if (
        self.modal.grid.gridDatas.filter(
          (x) => x.familyIDN === self.modal.form.familyIDN
        ).length > 1
      ) {
        errorMsg.push("身分證統一編號不得重複");
      }

      if (
        self.modal.form.familyTitle == "1" &&
        self.modal.grid.gridDatas.filter(
          (x) =>
            x.authDet_SEQ !== self.modal.form.authDet_SEQ &&
            x.familyTitle === self.modal.form.familyTitle
        ).length > 0
      ) {
        errorMsg.push("「配偶」(已有配偶資料，不可修改!)");
      }

      var dateNow = new Date(
        self.form.authOpenDate.substring(0, 4) +
          "-" +
          self.form.authOpenDate.substring(4, 6) +
          "-" +
          self.form.authOpenDate.substring(6, 8)
      );

      if (new Date(self.modal.form.familyBirthday) > new Date(Date.now())) {
        errorMsg.push("生日不可大於系統日");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      const modifyObj = {
        type: "U",
        authDet_SEQ: self.modal.form.authDet_SEQ,
        alertMsg: "修改成功",
      };
      this.btnModify(modifyObj);
    },
    //第二頁重填
    btnModalClear: function () {
      const self = this;
      self.modal.form.familyIDN = "";
      self.modal.form.familyName = "";
      self.modal.form.familyTitle = "";
      self.modal.form.familyBirthday = "";
      self.modal.form.SingleFLAG = false;
      self.EditFlag = false;
    },
    //第二頁查詢歷程
    btnHistoryModal: function () {
      const self = this;
      if (self.form.type == "1") {
        let postData = {
          idn: self.modal.PreData.idn,
          govCode: self.modal.PreData.goV_CODE,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁查詢歷程",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        M106_SearchGrid3(postData).then((rData) => {
          if (rData.result) {
            self.historyModal.grid = rData.returnObject;
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["權限錯誤，請重新登入．"];
            self.Alert.BtnConfirm = () => {
              logOut(self.pageData.ServiceUnit, self);
            };
          }
        });
      } else {
        let postData = {
          syear: self.form.syear,
          idn: self.modal.PreData.idn,
          govCode: self.modal.PreData.goV_CODE,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁查詢歷程",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        SearchM1063FGridType2(postData).then((rData) => {
          if (rData.result) {
            self.historyModal.grid = rData.returnObject;
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["權限錯誤，請重新登入．"];
            self.Alert.BtnConfirm = () => {
              logOut(self.pageData.ServiceUnit, self);
            };
          }
        });
      }
      self.historyModal.show = true;
    },
    //modal grid
    //第二頁編
    btnModalEdit: function (data) {
      const self = this;
      self.modal.form.familyIDN = data.familyIDN;
      self.modal.form.familyName = data.familyName;
      self.modal.form.familyTitle = data.familyTitle;
      (self.modal.form.familyBirthday = this.$moment(data.familyBirthday)._d),
        (self.modal.form.authDet_SEQ = data.authDet_SEQ);
      self.EditFlag = true;
      //self.modal.form.oneSeq = data.oneSeq;
      //fix
    },
    btnDelete: function (data) {
      const self = this;
      this.AlertDel.show = true;
      this.AlertDel.title = "提醒";
      this.AlertDel.form.authDet_SEQ = data.authDet_SEQ;
    },
    //第二頁刪除
    btnModalDel: function () {
      const modifyObj = {
        type: "D",
        authDet_SEQ: this.AlertDel.form.authDet_SEQ,
        alertMsg: "刪除成功",
      };
      this.btnModify(modifyObj);
      this.AlertDel.show = false;
    },
    //第二頁授權
    btnModalAuth: function (data) {
      const self = this;
      var msg = [];
      if (data.familyTitle != "0" && self.modal.grid.gridDatas[0].btnAuth) {
        self.Alert.show = true;
        self.Alert.title = "提醒";
        msg.push("主申報人必需先完成「授權」，配偶等才能授權");
        self.Alert.txt = msg;
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      }
      let postData = {
        enterPage: "M102",
        autH_SEQ:
          self.modal.PreData.autH_SEQ == 0
            ? self.modal.grid.gridDatas[0].auth_SEQ
            : self.modal.PreData.autH_SEQ,
        authDet_SEQ: data.authDet_SEQ,
        oneSeq: self.modal.grid.oneSeq,
        surveyDay: self.form.authOpenDate,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁授權",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      let formData = new FormData();
      formData.append("enterPage", "M102");
      formData.append(
        "autH_SEQ",
        self.modal.PreData.autH_SEQ == 0
          ? self.modal.grid.gridDatas[0].auth_SEQ
          : self.modal.PreData.autH_SEQ
      );
      formData.append("authDet_SEQ", data.authDet_SEQ);
      formData.append("oneSeq", self.modal.grid.oneSeq);
      formData.append("surveyDay", self.form.authOpenDate);
      formData.append("LogInfo.Id", self.loginInfo.id);
      formData.append("LogInfo.PrgCode", self.pageData.PrgName);
      formData.append("LogInfo.Token", self.loginInfo.token);
      formData.append("LogInfo.ActCd", "第二頁授權");
      formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);
      M1012_UploadFileAuthorize(formData).then((rData) => {
        if (rData.result) {
          self.Alert.enableClose = false;
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push("授權成功");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => {
            self.M102_SearchGrid2(self.modal.PreData);
            self.reQuery(self.Order, self.Sort);
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          msg.push("M102授權錯誤");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁取消授權
    btnModalCancelAuth: function (data) {
      const self = this;
      var msg = [];
      let postData = {
        enterPage: "M102",
        autH_SEQ:
          self.modal.PreData.autH_SEQ == 0
            ? self.modal.grid.gridDatas[0].auth_SEQ
            : self.modal.PreData.autH_SEQ,
        authDet_SEQ: data.authDet_SEQ,
        oneSeq: self.modal.grid.oneSeq,
        surveyDay: self.form.authOpenDate,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁取消授權",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      let formData = new FormData();
      formData.append("enterPage", "M102");
      formData.append(
        "autH_SEQ",
        self.modal.PreData.autH_SEQ == 0
          ? self.modal.grid.gridDatas[0].auth_SEQ
          : self.modal.PreData.autH_SEQ
      );
      formData.append("authDet_SEQ", data.authDet_SEQ);
      formData.append("oneSeq", self.modal.grid.oneSeq);
      formData.append("surveyDay", self.form.authOpenDate);
      formData.append("LogInfo.Id", self.loginInfo.id);
      formData.append("LogInfo.PrgCode", self.pageData.PrgName);
      formData.append("LogInfo.Token", self.loginInfo.token);
      formData.append("LogInfo.ActCd", "第二頁取消授權");
      formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);
      M1012_UploadFileAuthorize(formData).then((rData) => {
        if (rData.result) {
          self.Alert.enableClose = false;
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push("取消授權成功");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => {
            self.M102_SearchGrid2(self.modal.PreData);
            self.reQuery(self.Order, self.Sort);
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          msg.push("M102取消授權錯誤");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁送審
    btnModalSend: function (data) {
      const self = this;
      var authSeqList = [];
      let postData = {
        enterPage: "M102",
        authDet_SEQ: data.authDet_SEQ,
        oneSeq: self.modal.grid.oneSeq,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁送審",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M1012_SendAuth(postData).then((rData) => {
        var msg = [];
        if (rData.result) {
          self.Alert.enableClose = false;
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push("送審成功");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => {
            self.M102_SearchGrid2(self.modal.PreData);
            self.reQuery(self.Order, self.Sort);
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          msg.push(rData.messages[0]);
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁退回送審
    btnModalBack: function (data) {
      const self = this;
      var authSeqList = [];
      let postData = {
        enterPage: "M102",
        authDet_SEQ: data.authDet_SEQ,
        oneSeq: self.modal.grid.oneSeq,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁退回",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M1012_BackAuth(postData).then((rData) => {
        var msg = [];
        if (rData.result) {
          self.Alert.enableClose = false;
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push("退回成功");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => {
            self.M102_SearchGrid2(self.modal.PreData);
            self.reQuery(self.Order, self.Sort);
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          msg.push("M102退回錯誤");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    changeYear: function (data) {
      const self = this;
      if (data == "1") {
        self.form.syear = self.dropDownList.syears[0];
      }
      if (data == "2") {
        self.form.syear = String(Number(self.dropDownList.syears[0]) - 1);
      }
    },
    syearChange: function (data) {
      const self = this;
      if (data == "1") {
        self.dropDownList.authOpenDates = [];
        self.form.authOpenDate = "";
        let data = {
          serviceUnit: this.pageData.ServiceUnit,
          syear: this.form.syear,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "下拉查詢",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        M104_SearchDropDown(data).then((rData) => {
          if (rData.returnObject != null) {
            self.dropDownList.authOpen = rData.returnObject;
            self.dropDownList.authOpenDates = rData.returnObject.map(
              (x) => x.authOpenDate
            );
            //add
            debugger;
            self.form.authOpenDate = rData.returnObject[0].authOpenDate;
            self.form.stSdate = rData.returnObject[0].stSdate;
            self.form.endSdate = rData.returnObject[0].endSdate;
            debugger;
          }
        });
      }
    },
    authOpenDateChange: function () {
      const self = this;
      let data = self.dropDownList.authOpen.filter(
        (x) => x.authOpenDate == self.form.authOpenDate
      )[0];
      self.form.stSdate = data.stSdate;
      self.form.endSdate = data.endSdate;
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "modal.form.familyIDN": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.modal.form.familyIDN = newValue.toUpperCase();
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }

    if (self.loginInfo.layerNum != "1") {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = [
        "抱歉，本功能為「M102查調名單彙整」，僅提供「一級主管機關」使用。您並非一級主管機關，無法使用本功能，請至「M101查調名單管理」進行操做。",
      ];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    self.JobGovCodeInit(self.form);
    self.getSearchJobGovCode1();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
